import styled from 'styled-components';

export const Title = styled.h1`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding: 0 10px;
  color: rgba(0, 0, 0, 0.85);
`;
